import React from 'react';
import {
  Wrapper,
  ImageContainer,
  ImageElement,
  ImageCaption,
} from './Image.styles';
import { BASE_URL } from '../../config';

const Image = ({ content }) => {
  const { caption, alt, singleSRC } = content;

  return (
    <Wrapper>
      <ImageContainer>
        <ImageElement
          alt={alt ? alt : ''}
          src={`${BASE_URL}${singleSRC.img.src}`}
        />
        {caption !== '' && (
          <ImageCaption dangerouslySetInnerHTML={{ __html: caption }} />
        )}
      </ImageContainer>
    </Wrapper>
  );
};

export default Image;
